import { get, merge, omit, pick } from 'lodash';
import React, { PropTypes } from 'react';
import { getDataType } from '../../../../../../lib/staticData';
import { getSchema } from '../../../../../../models/reference';
import ValidatedForm from '../../../../../../common/components/ValidatedForm';
import TextField from '../../../../../../common/components/c_TextField';
import MaskedTextField from '../../../../../../common/components/c_MaskedTextField';
import DropDown from '../../../../../../common/components/c_DropDownMenu';
import { validateObject } from '../../../../../../lib/validation/validator';

export default class Reference extends ValidatedForm {
  static propTypes = {
    reference : PropTypes.object.isRequired,
    validation : PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired,
    index : PropTypes.number,
    showRemove : PropTypes.bool
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation : Object.assign({}, props.validation)
    };
  }

  get validationSchema() {
    const referenceRelationshipTypes = getDataType('referenceRelationshipTypes');
    return getSchema({referenceRelationshipTypes});
  }

  // Override: ValidatedForm.formModel
  get formModel() {
    return merge({}, get(this, 'props.reference'), get(this, `props.tempState.references[${this.props.reference.clientId}]`));
  }

  // Override: ValidatedForm.validateForm
  validateForm() {
    const state = merge({}, get(this, 'state'));
    const reference = this.formModel;
    const [valid, validation] = this.validate(reference);
    this.setState({...state, validation});
    return valid;
  }

  // Override: ValidatedForm.validateUpdate
  validateUpdate(model, field, callback) {
    return (event, value) => {
      const reference = this.formModel;
      reference[field] = value;
      const [valid, validation] = this.validate(reference);

      const newState = merge({}, omit(this.state, [`validation.${field}`]), {
        validation: {
          ...(pick(validation, [field]))
        }
      });

      this.setState(newState);
      if (callback) {
        callback(model, field, event, value);
      }
    };
  }

  validate(reference) {

    const form = validateObject(reference, this.validationSchema);
    const errors = (typeof form.errors === 'string') ? {} : form.errors;

    return [form.valid, errors];

  }

  handleRemove(clientId) {
    return () => this.props.onRemove(clientId);
  }

  handleUpdate = (clientId, prop) =>
    (model, field, event, value) => this.props.onChange(clientId, prop, event, value)

  renderAttributes(prop, label, updateOn = 'onBlur', valueOn = 'defaultValue') {
    return {
      floatingLabelText: label,
      'data-id': `${prop} ${this.props.index}`,
      [valueOn]: (this.props.reference[prop]),
      isDirty: !!get(this.state, `validation.${prop}[0]`, false),
      errorText: get(this.state, `validation.${prop}[0]`),
      [updateOn]: this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))
    };
  }

  renderMenuItems(items) {
    return {
      menuItems: typeof items === 'string' ? this.props.staticData[items] : items
    };
  }

  render() {
    const reference = this.props.reference;
    const index = this.props.index;
    const showRemove = this.props.showRemove;

    return (
      <div
        key={index}
        className='reference form-contents'
      >
        <TextField
          {...this.renderAttributes('name', 'Reference Name')}
        />
        <MaskedTextField
          mask='(999) 999-9999'
          hideMaskChar
          {...this.renderAttributes('phoneNumber', 'Phone Number')}
        />
        <TextField
          {...this.renderAttributes('position', 'Position')}
        />
        <MaskedTextField
          mask='999'
          hideMaskChar
          {...this.renderAttributes('yearsKnown', 'Years Known')}
        />
        <TextField
          {...this.renderAttributes('company', 'Company')}
        />
        <DropDown
          className = 'relationship-container'
          canAutoPosition='true'
          {...this.renderAttributes('relationshipId', 'Relationship', 'onChange', 'value')}
          {...this.renderMenuItems('referenceRelationshipTypes')}
        >
        {{
          Other: (
            <TextField
              className='other-relationship'
              {...this.renderAttributes('relationshipOther', 'Other Relationship')}
            />
          )
        }}
        </DropDown>
        {
          (showRemove)
          &&
          <div
            data-id='remove-section'
            className='remove-section text-btn noTextSelect'
            onClick={this.handleRemove(reference.clientId)}
          >
            Remove Reference
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Background/c_AdditionalReferences/Reference.js